import { Box, Typography } from '@mui/material';
import { memo, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ProbabilityRange } from '../types';
import { getProbabilityColor } from '../utils';

export interface MaterialChipProps {
  primaryText: string;
  secondaryText: string;
  probability: ProbabilityRange;
}

export const MaterialChip = memo(function (props: MaterialChipProps): ReactElement {
  const { t } = useTranslation();
  const { primaryText, secondaryText, probability } = props;
  return (
    <Box
      sx={{
        minHeight: '4rem',
        display: 'flex',
        flexDirection: 'row', // Explicitly set to row for horizontal layout
        alignItems: 'stretch',
        borderRadius: '10px',
        backgroundColor: 'white',
        border: '1px solid rgba(0, 0, 0, 0.12)',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        flex={1}
        sx={{
          padding: '8px 12px', // Move padding to content area only
        }}
      >
        <Typography
          align='center'
          variant='body1'
          sx={{
            fontWeight: 700,
          }}
        >
          {primaryText}
        </Typography>
        {secondaryText && (
          <Typography align='center' variant='inherit'>
            {t(secondaryText)}
          </Typography>
        )}
      </Box>

      {/* Probability indicator strip - same as AttributeChip */}
      <Box
        sx={{
          width: '5px',
          backgroundColor: getProbabilityColor(probability),
          borderRadius: '0px 10px 10px 0px',
          flexShrink: 0,
          alignSelf: 'stretch',
        }}
      />
    </Box>
  );
});
